export default "__VITE_ASSET__lwU2eu2g__"